// extracted by mini-css-extract-plugin
module.exports =  {"tc-length-badge":"LengthBadge-module__tc-length-badge___rEP98"};